<template>
  <div id="home">
    <h2 class="documentation-header pl-4">Official Docs</h2>
    <div class=" pl-4" style="margin-top: 1%">
      <h6>Train your BOT to bring in efficiency to your business processes.</h6>
      <br>
      <h6> Users can find all that is required to get started, train the BOT and deploy it. For integration with SDKs/APIs, third party Web-frameworks & Messaging-frameworks follow the simple steps provided in the side-menu. </h6>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-sm-3 p-4 bg-color c-p" @click="open_section('getting_started')">
          <div class="text-center p-2 mh-img">
            <img src="@/assets/img/integration/GettingStarted.svg" alt="" />
          </div>
          <div class="intro-sect-header">Getting started</div>
          <div class="intro-set-text">
            Learn how to create intents & train the BOT
          </div>
        </div>
        <!-- <div class="col-sm-2 p-4 bg-color m-2 c-p" @click="open_section('admin_guide')">
          <div class="text-center p-2 mh-img">
            <img src="@/assets/img/integration/AdminGuide.svg" alt="" />
          </div>
          <div class="intro-sect-header">Admin Guide</div>
          <div class="intro-set-text">
            Detailed administrative steps & configuration explained in this guide
          </div>
        </div> -->
        <div class="col-sm-3 p-4 bg-color  c-p" @click="open_section('sdk_apis')">
          <div class="text-center p-2 mh-img">
            <img src="@/assets/img/integration/SDKAPIs.svg" alt="" />
          </div>
          <div class="intro-sect-header">SDK and APIs</div>
          <div class="intro-set-text">
            Steps to integrate with iOS, Android & Web apps
          </div>
        </div>
        <div class="col-sm-3 p-4 bg-color c-p" @click="open_section('commerce_platform')">
          <div class="text-center p-2 mh-img">
            <img src="@/assets/img/integration/CommercePlatformIntegration.svg" alt="" />
          </div>
          <div class="intro-sect-header">Commerce Platform Integration</div>
          <div class="intro-set-text" style="margin-top: 0.55rem;">
            Steps to integrate with popular commerce frameworks
          </div>
        </div>
        <div class="col-sm-3 p-4 bg-color m c-p" @click="open_section('messaging_platform')">
          <div class="text-center p-2 mh-img">
            <img src="@/assets/img/integration/MessagingPlatformIntegration.svg" alt="" />
          </div>
          <div class="intro-sect-header">Messaging Platform Integration</div>
          <div class="intro-set-text" style="margin-top: 0.55rem;">
            Steps to integrate with popular messaging frameworks
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import $ from 'jquery';
export default {
  name: "DocsHome",
  methods: {
    open_section(section){
      $("#"+section).click();  
    }
  }
}
</script>
<style scoped>
.bg-color {
  background: #f9fcff 0% 0% no-repeat padding-box;
}
.intro-sect-header {
  font: normal normal 500 0.65rem/1.15rem Rubik;
  letter-spacing: 0px;
  color: #3a3a3a;
  text-transform: uppercase;
  opacity: 1;
  margin-top: 1.4rem;
  text-align: center;
}
.intro-set-text {
  margin-top: 1.4rem;
  font: normal normal normal 0.75rem/1.25rem Rubik;
  letter-spacing: 0px;
  color: #3a3a3a;
  opacity: 1;
  text-align: center;
}
.mh-img{
  min-height: 13vh;
}
.c-p{
  cursor: pointer;
}
</style>